import { Dispatch, Action } from 'redux'
import { ConfirmEmailMainMapDispatchReturnType } from './types/ConfirmEmailMainMapDispatchReturnType'

export const ConfirmEmailMainMapDispatch = (
  _dispatch: Dispatch<Action>
): ConfirmEmailMainMapDispatchReturnType => {
  return {}
}
